import { Notify } from 'quasar'
import { useDetectDevice } from '@/composables/device'

export const useNotify = () => {
  const { isMobile } = useDetectDevice()

  const notify = (config) => {
    const dismiss = Notify.create({
      ...config,
      attrs: isMobile.value ? { onClick: () => dismiss(), ...config.attrs } : config.attrs
    })
    return dismiss
  }

  const notifyInfo = (message, config) =>
    notify({ message: message, color: 'info', icon: 'mdi-information-outline', ...config })

  const notifySuccess = (message, config) =>
    notify({ message: message, color: 'positive', icon: 'mdi-check-circle-outline', ...config })

  const notifyError = (message, config) =>
    notify({ message: message, color: 'negative', icon: 'mdi-alert-outline', ...config })

  const notifyWarning = (message, config) =>
    notify({
      message: message,
      color: 'warning',
      textColor: 'dark',
      icon: 'mdi-alert-circle-outline',
      ...config
    })

  return { notifyInfo, notifySuccess, notifyError, notifyWarning }
}
